import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { SearchtoolboxService } from "../_services/searchtoolbox.service";
import { PersonSearchService } from '../_services/person-search.service';
import { DataService } from 'src/app/data.service';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { SaveSearchModalComponent } from '../save-search-modal/save-search-modal.component';
import * as _ from 'underscore';
import { GeneralConstants } from '../constants/GeneralConstants';
import { HashService } from '../_services/hash.service';
import { JdDataService } from '../jd-data.service';
import { JobDescriptionKeys } from '../common-interfaces-classes/JobDescriptionKeys';


@Component({
  selector: 'app-search-history',
  templateUrl: './search-history.component.html',
  styleUrls: ['./search-history.component.scss']
})
export class SearchHistoryComponent implements OnInit {

  @Input() save: boolean = false;
  @Input() calledFrom:any;
  @Input() events: Observable<void>

  starthistory: any = 0;
  @Output() viewHistoryUpdate :  EventEmitter<any> = new EventEmitter();
  @Output() viewSavedHistoryUpdate :  EventEmitter<any> = new EventEmitter();
  
  @ViewChild('historymodal') historymodal: TemplateRef<any>;
  @ViewChild('deleteSavedSearchModal') deleteSavedSearchModal: TemplateRef<any>;

  searchToolboxHistory: any[] = [];
  currentUserId: number | string = null;
  successMessage: string = null;
  errorMessage: string = null;
  deleteModalRef: NgbModalRef = null;
  savedSearchToDelete: any = null;

  constructor( private router: Router, 
               private personSearchService: PersonSearchService,  
               private _localstorageservice: LocalStorageService, 
               private dataService: DataService,
               private modalService: NgbModal,
               private hashService: HashService,
               private jdDataService: JdDataService
             ){}

  ngOnInit() {
    this.currentUserId = this._localstorageservice.getItem('userid');
    if(this.events){
      this.events.subscribe((ev:any) => {
        if(ev === 'REFRESH') {
          this.gethistory(null, true);
        } else {
          this.openHistoryModal()
        }
      })
    }
    this.gethistory();
  }

  formatDate(x) {
    return moment(x).format('Do MMM YY | hh:mm A')
  }

  gethistory(data: any = null, saveMode: boolean = false) {

    if(data == 'pagination'){
      this.starthistory = this.starthistory + 10
    }else {
      this.searchToolboxHistory = []
    }
    this.personSearchService[(this.save || saveMode) ? 'getSaveSearchHistory' : 'getSearchHistory'](this.starthistory).subscribe((result: any) => {
      if(result && result.status == 'success' && result.message && Array.isArray(result.message) && result.message.length){
        this.searchToolboxHistory = this.searchToolboxHistory.concat(result.message)
        this.searchToolboxHistory = this.searchToolboxHistory.map(obj => {
          const title = this.modifyQuery(obj.query);
          return { ...obj, title };
      });      
      this[this.save ? 'viewSavedHistoryUpdate' : 'viewHistoryUpdate'].emit(this.searchToolboxHistory)
        // this.saveHistory = this.searchToolboxHistory.filter(x => x.issaved == 1)
      }
    });

  }


  searchFromHistory(history){
    this.modalService.dismissAll();
    const query = JSON.parse(history.query)
    if(query && !query.hasOwnProperty('talentdiscoveryhistoryid')){
      query['talentdiscoveryhistoryid'] = history.talentdiscoveryhistoryid
    }
    const allLists = {
      jobTitleSelectedList: this.addKeyToArray(query, 'jobtitle'),
      pastJobTitleSelectedList: this.addKeyToArray(query, 'pastjobtitle'),
      skillsSelectedList: this.addKeyToArray(query, 'skills'),
      industrySelectedList: this.addKeyToArray(query, 'industry'),
      locationSelectedList: this.addKeyToArray(query, 'location'),
      companySelectedList: this.addKeyToArray(query, 'companies'),
      educationSelectedList: this.addKeyToArray(query.educationaldegrees),
      fieldOfStudySelectedList: this.addKeyToArray(query.educationalmajors),
      schoolSelectedList: this.addKeyToArray(query.schools),
      schoolLocationSelectedList: this.addKeyToArray(query, 'schoollocation'),
      // gender: this.gender,
      // yearsofgraduationFrom: this.fromgraduationyears,
      // yearsofgraduationTo: this.tograduationyears,
      // contactsAvailableArray: contactsAvailableArray,
      // contactSelectedList: contactSelectedList,
      yearsofexperienceFrom: query.fromyearsofexperience && query.fromyearsofexperience.length ? query.fromyearsofexperience[0] : null,
      yearsofexperienceTo: query.toyearsofexperience && query.toyearsofexperience ? query.toyearsofexperience[0] : null,
      companyStatus: query.companytype.toString().toLocaleLowerCase() == 'all' ? 'Current or Past' :  this.capitalizeFirstLetter(query.companytype),
      jobTitleStatus: query.jobtitletype.toString().toLocaleLowerCase() == 'all' ? 'Current or Past' :  this.capitalizeFirstLetter(query.jobtitletype),
      industryStatus: query.industrytype.toString().toLocaleLowerCase() == 'all' ? 'Current or Past' :  this.capitalizeFirstLetter(query.industrytype),
      yearsofexperience: this.capitalizeFirstLetter(query.experiencetype),
      companysize : this.addKeyToArray(query.companysizes, "companysize"),      
      gender: this.getGenderResult(query.gender),
      filterLikelyToMoveIn: (query.likelytomovetype == null || query.likelytomovetype.toString().toLowerCase() == 'all') ? 'All' : this.capitalizeFirstLetter(query.likelytomovetype),
      continentstobeincluded: query.continentstobeincluded.toString().split('; ') || null,
      functionSelectedList: query.functions && query.functions.length ? this.addKeyToArray(query.functions): [],
      seniority:  query.seniority && query.seniority.length ? this.addKeyToArray(query.seniority, "seniority"): [],
      fullnameSelectedList: query?.fullnames && query?.fullnames.length ? this.addKeyToArray(query.fullnames): [],
      changedjobsstartdurationinmonths: query?.changedjobsstartdurationinmonths || 0,
      changedjobsenddurationinmonths: query?.changedjobsenddurationinmonths || 12,
      changedjobs: (query?.changedjobs === 'no' && (!(query?.changedjobsstartdurationinmonths) || query?.changedjobsstartdurationinmonths === 0)) ? null : query?.changedjobs,
      
      distancefromselectedlocationsmeasurementunit: query?.distancefromselectedlocationsmeasurementunit,
      distancefromselectedlocations: query?.distancefromselectedlocations,
      currentfromyearsofexperience: query.currentfromyearsofexperience && query.currentfromyearsofexperience.length ? query.currentfromyearsofexperience[0] : null,
      currenttoyearsofexperience: query.currenttoyearsofexperience && query.currenttoyearsofexperience ? query.currenttoyearsofexperience[0] : null,
    };

    if((query.linkedinurl !== '' && query.linkedinurl !== null) || query.isUploadedFromResume === true){
      allLists['isSimilarCanidate'] = true
      allLists['similarCanidateFullName'] = query.fullname
      allLists['hideSearchBox'] = false
      const totalTenure = query.similarcandidates_totaltenure || 0;  
      const fromYrsOfExperience = query.similarcandidates_fromyearsofexperience ? query.similarcandidates_fromyearsofexperience : (parseInt(totalTenure) - (parseInt(totalTenure) * 0.25));
      const toYrsOfExperinece = query.similarcandidates_toyearsofexperience ? query.similarcandidates_toyearsofexperience : (parseInt(totalTenure) + (parseInt(totalTenure) * 0.25));

      allLists['similarobject'] = {
        ['data'] : {
        jobtitle: (query.similarcandidates_jobtitles && query.similarcandidates_jobtitles.length && query.newsimilarcandidateflow) ? query.similarcandidates_jobtitles.split(";").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_jobtitles && query.similarcandidates_jobtitles.length && !query.newsimilarcandidateflow ? query.similarcandidates_jobtitles.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: true })) : [],
        jobindustryname:  (query.similarcandidates_industries && query.similarcandidates_industries.length && query.newsimilarcandidateflow) ? query.similarcandidates_industries.split("; ").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_industries && query.similarcandidates_industries.length && !query.newsimilarcandidateflow ? query.similarcandidates_industries.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: true })) : [],
        companysize: (query.similarcandidates_companysizes && query.similarcandidates_companysizes.length && query.newsimilarcandidateflow) ? query.similarcandidates_companysizes.split("; ").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_companysizes && query.similarcandidates_companysizes.length && !query.newsimilarcandidateflow ? query.similarcandidates_companysizes.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: false })) : [],
        skills: (query.similarcandidates_skills && query.similarcandidates_skills.length && query.newsimilarcandidateflow) ? query.similarcandidates_skills.split(";").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_preferredskills && query.similarcandidates_preferredskills.length && !query.newsimilarcandidateflow ? query.similarcandidates_preferredskills.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: false })) : [], 
        currentlocation: (query.similarcandidates_locations && query.similarcandidates_locations.length && query.newsimilarcandidateflow) ? query.similarcandidates_locations.split("; ").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_locations && query.similarcandidates_locations.length && !query.newsimilarcandidateflow ? query.similarcandidates_locations.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: false })) : [],
        jobcompanyname: (query.similarcandidates_companies && query.similarcandidates_companies.length && query.newsimilarcandidateflow) ? query.similarcandidates_companies.split("; ").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_companies && query.similarcandidates_companies.length && !query.newsimilarcandidateflow ? query.similarcandidates_companies.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: false })) : [],
        linkedinurl: query.linkedinurl,
        isUploadedFromResume: query.isUploadedFromResume ? true : false,
        totaltenure: query.similarcandidates_totaltenure,
        elasticid: query.exclude_persons && typeof query.exclude_persons === 'object' ? query.exclude_persons[0] : query.exclude_persons,
        fullname: query.fullname != '' ? query.fullname : '',
        changedjobsstartdurationinmonths: query?.changedjobsstartdurationinmonths || 0,
        changedjobsenddurationinmonths: query?.changedjobsenddurationinmonths || 12,
        changedjobs: (query?.changedjobs === 'no' && (!(query?.changedjobsstartdurationinmonths) || query?.changedjobsstartdurationinmonths === 0)) ? null : query?.changedjobs,
        distancefromselectedlocationsmeasurementunit: query?.distancefromselectedlocationsmeasurementunit,
        distancefromselectedlocations: query?.distancefromselectedlocations,
        locationcontinent: query.continentstobeincluded || null,
        fromYrsOfExperience,
        toYrsOfExperinece
      }
    }
    }

  
  
    for (const key in allLists) {
      if (allLists.hasOwnProperty(key) && allLists[key] === undefined) {
          allLists[key] = []
      }
    }
      
    let data = {
      allLists: allLists,
      requestObject: this.modifyRequestObject(query),
       calledFrom: 'history',
    }

    let keyword = ''
    if(query.booleanquery !== '*'){
      keyword = query.booleanquery
    }
    
    this.dataService.setData(data);
    let queryParams = {}
    queryParams['keyword'] = keyword
    queryParams['searchSource'] = 'history-component'
    if(query && query.searchedfrom !== ''){
      queryParams['type'] = query.searchedfrom;
    }
    if (query?.searchedfrom === GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
      // Only getSimilarObjFromHistory method should be needed to be updated once I update the logic in backend...
      query.continentstobeincluded && this._localstorageservice.setItem("similar-region", query.continentstobeincluded);
      const similarObject = this.jdDataService.getSimilarObjFromHistory(query);
      const uniqueHash = this.hashService.generateUniqueHash();
      this.jdDataService.setSessionData(uniqueHash, similarObject);
      queryParams['uniqueHash'] = uniqueHash;
    }
    this.router.navigate(['/person/search/listing'], { queryParams: queryParams });
  }
  addKeyToArray(data: any, type: any = null) {
    if (data != null) {
      let modifiedData = []
      if (type == 'skills') {
        if (data.preferredskills && data.preferredskills.length) {
          let preferredskills = data.preferredskills.split('; ').map(v => Object.assign({ key: v, isMandatory: false, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'skill', key: this.getSafeKey(v.replace('.aisearch', '')) } }));
          preferredskills.forEach(element => modifiedData.push(element));
        }

        if (data.mandatoryskills && data.mandatoryskills.length) {
          let mandatoryskills = data.mandatoryskills.split('; ').map(v => Object.assign({ key: v, isMandatory: true, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'skill', key: this.getSafeKey(v.replace('.aisearch', '')) } }));
          mandatoryskills.forEach(element => modifiedData.push(element));

        }
        return modifiedData;
      } else if (type == 'jobtitle') {
        if (data.jobtitles && data.jobtitles.length) {
          let preferredJobList = data.jobtitles.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: false, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'title', key: this.getSafeKey(v.replace('.aisearch', '')) } }));
          preferredJobList.forEach(element => modifiedData.push(element));
        }

        if (data.exclude_jobtitles && data.exclude_jobtitles.length) {
          let excludedJobList = data.exclude_jobtitles.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'title', key: this.getSafeKey(v.replace('.aisearch', '')) } }));
          excludedJobList.forEach(element => modifiedData.push(element));
        }

        return modifiedData;

      } else if (type == 'location') {
        if (data.locations && data.locations.length) {
          let preferredLocation = data.locations.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: false, chipkey: v.replace('.searchastext', '').replace('.iplocation', '') })).filter(l => !l.key.includes('.iplocation'))
          preferredLocation.forEach(element => modifiedData.push(element));
        }
        if (data.exclude_locations && data.exclude_locations.length) {
          let excludedLocation = data.exclude_locations.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, chipkey: v.replace('.searchastext', '').replace('.iplocation', '') }));
          excludedLocation.forEach(element => modifiedData.push(element));
        }
        return modifiedData;

      } else if (type == 'companies') {
        if (data.companies && data.companies.length) {
          let preferredCompanies = data.companies.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: false, chipkey: v.replace('.searchastext', '') }));

          preferredCompanies.forEach(element => modifiedData.push(element));
        }
        if (data.exclude_companies && data.exclude_companies.length) {

          let excludedCompanies = data.exclude_companies.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, chipkey: v.replace('.searchastext', '') }));

          excludedCompanies.forEach(element => modifiedData.push(element));

        }
        return modifiedData;
      } else if (type == "companysize") {
        let preferredCompanieSize = data.toString().split('; ').map(item => item.trim());
        preferredCompanieSize.forEach(element => {
          modifiedData.push(element)
        })
        return modifiedData;
      } else if (type == "seniority") {
        let preferredSeniority = data.toString().split('; ').map(item => item.trim());
        preferredSeniority.forEach(element => {
          modifiedData.push(element)
        })
        return modifiedData;
      } else if (type === "pastjobtitle") {
        if (data.pastjobtitles && data.pastjobtitles.length) {
          let preferredPastJobList = data.pastjobtitles.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: false, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'title', key: this.getSafeKey(v.replace('.aisearch', '')) }  }));
          preferredPastJobList.forEach(element => modifiedData.push(element));
        }

        if (data.exclude_pastjobtitles && data.exclude_pastjobtitles.length) {
          let excludedPastJobList = data.exclude_pastjobtitles.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'title', key: this.getSafeKey(v.replace('.aisearch', '')) }  }));
          excludedPastJobList.forEach(element => modifiedData.push(element));
        }
      } else if (type == 'industry') {
        if (data.industries && data.industries.length) {
          let industryList = data.industries.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: false, chipkey: v.replace('.searchastext', '') }));
          industryList.forEach(element => modifiedData.push(element));
        }

        if (data.exclude_industries && data.exclude_industries.length) {
          let excludedIndustryList = data.exclude_industries.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, chipkey: v.replace('.searchastext', '') }));
          excludedIndustryList.forEach(element => modifiedData.push(element));
        }
      return modifiedData;

    } else if (type == 'schoollocation') {
      if (data.schoollocation && data.schoollocation.length) {
        let schoollocationList = data.schoollocation.toString().split(';').map(v => Object.assign({ key: v.trim(), isExcluded: false, chipkey: v.replace('.searchastext', '').trim() }));
        schoollocationList.forEach(element => modifiedData.push(element));
      }

        if (data.exclude_schoollocation && data.exclude_schoollocation.length) {
          let excludedschoollocationList = data.exclude_schoollocation.toString().split(';').map(v => Object.assign({ key: v.trim(), isExcluded: true, chipkey: v.replace('.searchastext', '').trim() }));
          excludedschoollocationList.forEach(element => modifiedData.push(element));
        }
        return modifiedData;
      }
      else {
        modifiedData = data.split('; ').map(v => Object.assign({ key: v, chipkey: v.replace('.searchastext', '').replace('.aisearch', '').replace('.iplocation', '') }));
      }
      return modifiedData;
    }
  }

  private getJdDataFromPayload(payload) {
    const jdData: JobDescriptionKeys = payload?.job_description_keys;
    for (const key in jdData) {
      jdData[key] = this.splitIfString(jdData[key]);
    }
    return jdData;
  }

  private splitIfString(el) {
    if (typeof el === "string") {
      return el.split(";").map(el => el.trim());
    }
    if (Array.isArray(el))
      return el;
    return []; 
  } 

  private stringifyFilters(jdFilterData: JobDescriptionKeys) {
    let result = "";
    for (const key in jdFilterData) {
      if (
        !jdFilterData[key] ||
        (Array.isArray(jdFilterData[key]) && jdFilterData[key].length === 0)
      ) continue;

      result += `${GeneralConstants.JD_FILTER_KEY_NAME_MAP[key]} : `;
      if (Array.isArray(jdFilterData[key]) && jdFilterData[key].length > 0)
        jdFilterData[key].forEach(el => result += `${el}, `);
      else 
        result += jdFilterData[key];
    }
    return result;
  }

  modifyQuery(query){
    const payload = JSON.parse(query);
    const jdFilterData = this.getJdDataFromPayload(payload);
    let jdFilterHistory = "";
    if (!_.isEmpty(jdFilterData)) {
      jdFilterHistory = this.stringifyFilters(jdFilterData);
    }

    const modifedPayload = this.modifyQueryForUi(payload)

    let formattedString = ''
    let originalFormattedString = ''
    if(modifedPayload){
      if(modifedPayload.jobtitles && modifedPayload.jobtitles.length){
        formattedString = formattedString  + ` | Job Title : ${modifedPayload.jobtitles.map(x=>{x=x.replace('.searchastext','');return x;}).join(', ')} (${modifedPayload.jobtitletype === 'all' || modifedPayload.jobtitletype === 'All' ? 'Current or past' : modifedPayload.jobtitletype})` 
      }
      if (modifedPayload.pastjobtitles && modifedPayload.pastjobtitles.length) {
        formattedString = formattedString + ` | Past Job Title : ${modifedPayload.pastjobtitles.map(x => { x = x.replace('.searchastext', '').replace('.aisearch', ''); return x; }).join(', ')}`
      }
      if (modifedPayload.exclude_pastjobtitles && modifedPayload.exclude_pastjobtitles.length) {
        formattedString = formattedString + ` | Excluded Past Jobtitles: ${modifedPayload.exclude_pastjobtitles.map(x => { x = x.replace('.searchastext', '').replace('.aisearch', ''); return x; }).join(',')}`
      }
      if (modifedPayload.preferredskills && modifedPayload.preferredskills.length) {
          formattedString += ` | Skills: ${modifedPayload.preferredskills.map(x=>{x=x.replace('.searchastext','').replace('.aisearch', '');return x;}).join(', ')}\n`;
      }
  
      if (_.flatten(modifedPayload.companysizes) && Array.isArray(modifedPayload.companysizes) && modifedPayload.companysizes.length) {
        let mofifiedD =[]
          let data =modifedPayload.companysizes.map(item => item.trim())
        if(data.includes("All")){
          mofifiedD = ["All"]
          }else{
            mofifiedD=data;
          }
          if(mofifiedD.length){
            formattedString += ` | Company Size: ${mofifiedD.map(x=>{x=x.replace('.searchastext','');return x;}).join(', ')}\n`;
          }
      }
      if(modifedPayload.locations && modifedPayload.locations.length){
        const location = modifedPayload.locations.filter(l => !l.includes('.iplocation')).map(x=>{x=x.replace('.searchastext','').replace('.iplocation', '');return x;});
        formattedString += location && location.length ? ` | Location: ${location.join(':')}` : '';;
        if(modifedPayload?.distancefromselectedlocations){
          formattedString += ` | Distance : ${modifedPayload.distancefromselectedlocations} ${modifedPayload.distancefromselectedlocationsmeasurementunit}`;
        }
      }
      if(modifedPayload.companies && modifedPayload.companies.length){
        formattedString += ` | Company: ${modifedPayload.companies.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')} (${modifedPayload.companytype === 'all' || modifedPayload.companytype === 'All' ? 'Current or Past' : modifedPayload.companytype })`
      }
      if(modifedPayload.industries && modifedPayload.industries.length){
        formattedString = formattedString + ` | Industries: ${modifedPayload.industries.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')} (${modifedPayload.industrytype === 'all' || modifedPayload.industrytype === 'All' ? 'Current or Past' : modifedPayload.industrytype })`
      }
      if(modifedPayload.fromyearsofexperience && modifedPayload.fromyearsofexperience.length &&
         modifedPayload.toyearsofexperience && modifedPayload.toyearsofexperience.length){
          formattedString = formattedString + ` | ${modifedPayload.experiencetype} years of exp:  : ${modifedPayload.fromyearsofexperience[0]} - ${modifedPayload.toyearsofexperience[0]}`
      }
      if(modifedPayload.educationaldegrees && modifedPayload.educationaldegrees.length){
        formattedString = formattedString + ` | Education: ${modifedPayload.educationaldegrees.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`
      }

      if(modifedPayload.educationalmajors && modifedPayload.educationalmajors.length){
        formattedString = formattedString + ` | Field Of Study : ${modifedPayload.educationalmajors.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`
      }

      if(modifedPayload.schools && modifedPayload.schools.length){
        formattedString = formattedString + ` | Schools : ${modifedPayload.schools.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`

      }
      if(modifedPayload.likelytomovetype && modifedPayload.likelytomovetype.toLowerCase() !== 'all'){
        formattedString = formattedString + ` | Likely to Move: ${modifedPayload.likelytomovetype}`
      }

      if(modifedPayload.genders && modifedPayload.genders.length && modifedPayload.genders[0].toLowerCase() != 'all'){
        formattedString = formattedString + ` | Gender: ${this.showGender(modifedPayload.genders[0])}`
      }
      if(modifedPayload.exclude_jobtitles && modifedPayload.exclude_jobtitles.length){
        formattedString = formattedString + ` | Excluded Jobtitles: ${modifedPayload.exclude_jobtitles.map(x=>{x=x.replace('.searchastext','').replace('.aisearch', '');return x;}).join(',')} (${modifedPayload.jobtitletype === 'all' ? 'Current or past' : modifedPayload.jobtitletype})`  
      }

      if(modifedPayload.exclude_locations && modifedPayload.exclude_locations.length){
        formattedString += ` | Excluded Location: ${modifedPayload.exclude_locations.map(x=>{x=x.replace('.searchastext','').replace('.iplocation', '');return x;}).join(':')}`
      }
      
      if(modifedPayload.exclude_companies && modifedPayload.exclude_companies.length){
        formattedString += ` | Excluded Companies: ${modifedPayload.exclude_companies.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')} (${modifedPayload.companytype === 'all' ? 'Current or Past' : modifedPayload.companytype })`
      }
      
      if (modifedPayload.mandatoryskills && modifedPayload.mandatoryskills.length) {
        formattedString += ` | Mandatory Skills: ${modifedPayload.mandatoryskills.map(x=>{x=x.replace('.searchastext','').replace('.aisearch', '');return x;}).join(', ')}`;
      }

      if (modifedPayload.functions && modifedPayload.functions.length) {
        formattedString += ` | Functions: ${modifedPayload.functions.map(x=>{x=x.replace('.searchastext','');return x;}).join(', ')}`;
      }

      if (_.flatten(modifedPayload.seniority) && Array.isArray(modifedPayload.seniority) && modifedPayload.seniority.length) {

        let mofifiedD =[]
        let data =modifedPayload.seniority.map(item => item.trim())
        if(data.includes("All")){
          mofifiedD = ["All"]
          }else{
            mofifiedD=data;
          }
          if(mofifiedD.length){
            formattedString += ` | Seniority: ${mofifiedD.map(x=>{x=x.replace('.searchastext','');return x;}).join(', ')}\n`;
          }
      }
      if (modifedPayload.fullnames && modifedPayload.fullnames.length ) {
        formattedString += ` | Name: ${modifedPayload.fullnames.map(x=>{x=x.replace('.searchastext','');return x;}).join(', ')}\n`;
      }
   
      if (modifedPayload.changedjobs && modifedPayload.changedjobs === 'yes'){
        formattedString += ` | Changed Jobs: ${modifedPayload.changedjobs}`
      }
      
      if (modifedPayload.currentfromyearsofexperience && modifedPayload.currentfromyearsofexperience.length &&
        modifedPayload.currenttoyearsofexperience && modifedPayload.currenttoyearsofexperience.length
        ) {
        formattedString += ` |  Years In Current Company :  ${modifedPayload.currentfromyearsofexperience[0]} - ${modifedPayload.currenttoyearsofexperience[0]}\n`;
      }
      if(modifedPayload.exclude_industries && modifedPayload.exclude_industries.length){
        formattedString += ` | Excluded Industry: ${modifedPayload.exclude_industries.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`
      }
      if(modifedPayload.schoollocation && modifedPayload.schoollocation.length){
        formattedString += ` | Education Location: ${modifedPayload.schoollocation.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`
      }
      if(modifedPayload.exclude_schoollocation && modifedPayload.exclude_schoollocation.length){
        formattedString += ` | Excluded Education Location: ${modifedPayload.exclude_schoollocation.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`
      }
    
     if(modifedPayload && modifedPayload.booleanquery){
        if(modifedPayload.booleanquery === '*' && formattedString.length === 0 && modifedPayload.isUploadedFromResume === false && modifedPayload.linkedinurl === ''){
              originalFormattedString = `Search: All |`   
        }else{
             if(modifedPayload.booleanquery !== '*'){
                originalFormattedString = ` Search: ${modifedPayload.booleanquery} |`
             } 
             if((modifedPayload.booleanquery === '*' || modifedPayload.booleanquery !== '*') && (modifedPayload.isUploadedFromResume === true || modifedPayload.linkedinurl !== '')){
              if(modifedPayload.isUploadedFromResume === true){
                originalFormattedString += ` | Similar Candidates: Resume`
                }
                if(modifedPayload.linkedinurl != ''){
                  originalFormattedString += ` | Similar Candidates: Linkedin URL = ${modifedPayload.linkedinurl} `
                }
             }
             
        }

        originalFormattedString = originalFormattedString + formattedString 

      }

      if(!originalFormattedString.includes('Search: All')){
        originalFormattedString = originalFormattedString.replace("|", "")
      }else if(originalFormattedString.includes('Search: All')){
        originalFormattedString = originalFormattedString.replace("|", "")
      }
    


    }
    return jdFilterHistory.length > 0 ? `JD Search Filters | ${jdFilterHistory}. ` : '' + originalFormattedString.trim();
  }

  openHistoryModal() {
    this.starthistory = 0
    this.modalService.open(this.historymodal, { windowClass: "small-modal", centered: true })
    this.gethistory()
  }

  modifyQueryForUi(data){
    return  {
      startindex: data.startindex,
      resultsize: 1,
      searchviaboolean: true,
      booleanquery: data.booleanquery,
      jobtitles: data.jobtitles && data.jobtitles.length ? data.jobtitles.split('; '): [],
      pastjobtitles: data.pastjobtitles && data.pastjobtitles.length ? data.pastjobtitles.split('; '): [],
      preferredskills: data.preferredskills && data.preferredskills.length ? data.preferredskills.split('; '): [],
      mandatoryskills: data.mandatoryskills && data.mandatoryskills.length ? data.mandatoryskills.split('; '): [],
      locations: data.locations && data.locations.length ? data.locations.split('; ') : [],
      companies: data.companies && data.companies.length ? data.companies.split('; '): [],
      industries: data.industries && data.industries.length ? data.industries.split('; ') : [],
      exclusionlist: [],
      genders: data.gender != '' ? data.gender && data.gender.length ? [data.gender] : [] : [],
      seniority: data.seniority && data.seniority.length ? data.seniority.split(";") : [],
      graduationyear: data.graduationyear && data.graduationyear.length ? data.graduationyear.split('; ') : [], 
      schools: data.schools && data.schools.length ? data.schools.split('; ') : [],
      schooltypes: [],
      educationaldegrees: data.educationaldegrees && data.educationaldegrees.length ? data.educationaldegrees.split('; ') : [],
      educationalmajors: data.educationalmajors && data.educationalmajors.length ? data.educationalmajors.split('; ') : [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: data.candidateshavingcontactnumbers ? true : false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: data.zipcodes && data.zipcode.length ? data.zipcode : [],
      companysizes: data.companysizes && data.companysizes.length ? data.companysizes.split(";") : [],
      candidateshavingcontacts: data.candidateshavingcontacts ? true : false,
      // workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      // workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      // worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      // spokenlanguages: this.languageSelectedList.map(l => l.key),
      // contacts: this.contacts ? [this.contacts] : [],
      // candidateshavingmobilenumber: this.contactSelectedList.find(c => c.key.toLowerCase() == 'mobile number') ? true : false,
      // candidateshavingpersonalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'personal email') ? true : false,
      // candidateshavingprofessionalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'current professional email') ? true : false,
      // candidateshavingsocialprofiles: this.contactSelectedList.find(c => c.key.toLowerCase() == 'social profiles') ? true : false,
      // fromgraduationyears: this.yearsofgraduationFrom.value != null ? [this.yearsofgraduationFrom.value] : [],
      // tograduationyears: this.yearsofgraduationTo.value != null ? [this.yearsofgraduationTo.value] : [],
      exclude_jobtitles: data.exclude_jobtitles && data.exclude_jobtitles.length ? data.exclude_jobtitles.split('; '): [],
      exclude_pastjobtitles: data.exclude_pastjobtitles && data.exclude_pastjobtitles.length ? data.exclude_pastjobtitles.split('; '): [],
      exclude_companies: data.exclude_companies && data.exclude_companies.length ? data.exclude_companies.split('; '): [],
      exclude_locations: data.exclude_locations && data.exclude_locations.length ? data.exclude_locations.split('; '): [],
      companytype: data.companytype || null,
      jobtitletype: data.jobtitletype || null,
      industrytype: data.industrytype || null,
      fromyearsofexperience: data.fromyearsofexperience != null ? data.fromyearsofexperience : null,
      toyearsofexperience: data.toyearsofexperience != null ? data.toyearsofexperience : null,
      experiencetype: data.experiencetype,
      likelytomovetype : data.likelytomovetype,
      // salaries : this.salary ? [this.salary] :[]  ,
      // salaryranges : this.salary ? [this.salary] :[],
      talentdiscoveryhistoryid: data.talentdiscoveryhistoryid,
      calledfrom: 'listing',

      isUploadedFromResume: data.isUploadedFromResume ? true : false,
      linkedinurl: (data.linkedinurl !== '' && data.linkedinurl !== undefined && data.linkedinurl !== null ) ? data.linkedinurl : '',
      fullname: data.fullname != '' ? data.fullname : '',
      functions: data?.functions && data?.functions?.length ? data.functions.split('; '): [],
      fullnames: data?.fullnames && data?.fullnames?.length ? data.fullnames.split('; '): [],
      changedjobsstartdurationinmonths: data?.changedjobsstartdurationinmonths || 0,
      changedjobsenddurationinmonths: data?.changedjobsenddurationinmonths || 12,
      distancefromselectedlocationsmeasurementunit: data?.distancefromselectedlocationsmeasurementunit,
      distancefromselectedlocations: data?.distancefromselectedlocations,
      changedjobs: data?.changedjobs,
      currentfromyearsofexperience: data.currentfromyearsofexperience != null ? data.currentfromyearsofexperience : null,
      currenttoyearsofexperience: data.currenttoyearsofexperience != null ? data.currenttoyearsofexperience : null,
      exclude_industries: data.exclude_industries && data.exclude_industries.length ? data.exclude_industries.split(';'): [],
      schoollocation: data.schoollocation && data.schoollocation.length ? data.schoollocation.split(';'): [],
      exclude_schoollocation: data.exclude_schoollocation && data.exclude_schoollocation.length ? data.exclude_schoollocation.split(';'): [],
    }
  }

  modifyRequestObject(data){
    return  {
      startindex: data.startindex,
      resultsize: 20,
      searchviaboolean: true,
      booleanquery: data.booleanquery,
      jobtitles: data.jobtitles && data.jobtitles.length ? data.jobtitles.split('; '): [],
      pastjobtitles: data.pastjobtitles && data.pastjobtitles.length ? data.pastjobtitles.split('; '): [],
      exclude_pastjobtitles: data.exclude_pastjobtitles && data.exclude_pastjobtitles.length ? data.exclude_pastjobtitles.split(";") : [],
      preferredskills: data.preferredskills && data.preferredskills.length ? data.preferredskills.split('; '): [],
      mandatoryskills: data.mandatoryskills && data.mandatoryskills.length ? data.mandatoryskills.split('; '): [],
      locations: data.locations && data.locations.length ? data.locations.split('; ') : [],
      companies: data.companies && data.companies.length ? data.companies.split('; '): [],
      industries: data.industries && data.industries.length ? data.industries.split('; ') : [],
      exclusionlist: [],
      genders: data.gender != '' ? data.gender && data.gender.length ? [data.gender] : [] : [],
      seniority: data.seniority && data.seniority.length ? data.seniority.split('; ').map(item => item.trim()) : [],
      graduationyear: data.graduationyear && data.graduationyear.length ? data.graduationyear.split('; ') : [], 
      schools: data.schools && data.schools.length ? data.schools.split('; ') : [],
      schooltypes: [],
      educationaldegrees: data.educationaldegrees && data.educationaldegrees.length ? data.educationaldegrees.split('; ') : [],
      educationalmajors: data.educationalmajors && data.educationalmajors.length ? data.educationalmajors.split('; ') : [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: data.candidateshavingcontactnumbers ? true : false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: data.zipcodes && data.zipcode.length ? data.zipcode : [],
      companysizes: data.companysizes && data.companysizes.length ? data.companysizes.split('; ').map(item => item.trim()) : [],
      candidateshavingcontacts: data.candidateshavingcontacts ? true : false,
      // workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      // workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      // worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      // spokenlanguages: this.languageSelectedList.map(l => l.key),
      // contacts: this.contacts ? [this.contacts] : [],
      // candidateshavingmobilenumber: this.contactSelectedList.find(c => c.key.toLowerCase() == 'mobile number') ? true : false,
      // candidateshavingpersonalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'personal email') ? true : false,
      // candidateshavingprofessionalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'current professional email') ? true : false,
      // candidateshavingsocialprofiles: this.contactSelectedList.find(c => c.key.toLowerCase() == 'social profiles') ? true : false,
      // fromgraduationyears: this.yearsofgraduationFrom.value != null ? [this.yearsofgraduationFrom.value] : [],
      // tograduationyears: this.yearsofgraduationTo.value != null ? [this.yearsofgraduationTo.value] : [],
      exclude_jobtitles: data.exclude_jobtitles && data.exclude_jobtitles.length ? data.exclude_jobtitles.split('; ').map(item => item.trim()): [],
      exclude_companies: data.exclude_companies && data.exclude_companies.length ? data.exclude_companies.split('; ').map(item => item.trim()): [],
      exclude_locations: data.exclude_locations && data.exclude_locations.length ? data.exclude_locations.split('; ').map(item => item.trim()): [],
      companytype: data.companytype || null,
      jobtitletype: data.jobtitletype || null,
      industrytype: data.industrytype || null,
      fromyearsofexperience: data.fromyearsofexperience && data.fromyearsofexperience.length  ? data.fromyearsofexperience : [],
      toyearsofexperience: data.toyearsofexperience && data.toyearsofexperience.length ? data.toyearsofexperience : [],
      experiencetype: data.experiencetype,
      likelytomovetype : data.likelytomovetype,
      // salaries : this.salary ? [this.salary] :[]  ,
      // salaryranges : this.salary ? [this.salary] :[],
      // talentdiscoveryhistoryid: data.talentdiscoveryhistoryid,



      linkedinurl: (data.linkedinurl && data.linkedinurl != '') ? data.linkedinurl : null,
      isUploadedFromResume: (data.isUploadedFromResume && data.isUploadedFromResume == true) ? true : false,
      fullname: (data.fullname && data.fullname !== '') ? data.fullname : '',
      similarcandidates_industries: (data.similarcandidates_industries && data.similarcandidates_industries.length) ? data.similarcandidates_industries.split("; ") : null,
      similarcandidates_locations: (data.similarcandidates_locations && data.similarcandidates_locations.length) ? data.similarcandidates_locations.split("; ") : null,
      similarcandidates_companysizes: (data.similarcandidates_companysizes && data.similarcandidates_companysizes.length) ? data.similarcandidates_companysizes.split("; ") : null,
      similarcandidates_fromyearsofexperience: (data.similarcandidates_fromyearsofexperience && data.similarcandidates_fromyearsofexperience.length) ? data.similarcandidates_fromyearsofexperience.split("; ") : null,
      similarcandidates_toyearsofexperience: (data.similarcandidates_toyearsofexperience && data.similarcandidates_toyearsofexperience.length) ? data.similarcandidates_toyearsofexperience.split("; ") : null,
      similarcandidates_jobtitles: (data.similarcandidates_jobtitles && data.similarcandidates_jobtitles.length) ? data.similarcandidates_jobtitles.split("; ") : null,
      // similarcandidates_totaltenure: data.similarcandidates_totaltenure || null,
      exclude_persons: data.exclude_persons || null,  
      continentstobeincluded: data.continentstobeincluded.toString().split('; ') || null,
      calledfrom: 'listing',
      functions: data?.functions && data?.functions?.length ? data.functions.split('; '): [],
      fullnames: data?.fullnames && data?.fullnames?.length ? data.fullnames.split('; '): [],
      changedjobsstartdurationinmonths: data?.changedjobsstartdurationinmonths || 0,
      changedjobsenddurationinmonths: data?.changedjobsenddurationinmonths || 12,
      changedjobs: (data?.changedjobs === 'no' && (!(data?.changedjobsstartdurationinmonths) || data?.changedjobsstartdurationinmonths === 0)) ? null : data?.changedjobs,

      distancefromselectedlocationsmeasurementunit: data?.distancefromselectedlocationsmeasurementunit,
      distancefromselectedlocations: data?.distancefromselectedlocations,

      currentfromyearsofexperience: data.currentfromyearsofexperience != null ? data.currentfromyearsofexperience : null,
      currenttoyearsofexperience: data.currenttoyearsofexperience != null ? data.currenttoyearsofexperience: null,


      searchedfrom: (data.searchedfrom && data.searchedfrom != '') ? data.searchedfrom : '',
      exclude_industries: data.exclude_industries && data.exclude_industries.length ? data.exclude_industries.split('; ').map(item => item.trim()): [],

      schoollocation: data.schoollocation && data.schoollocation.length ? data.schoollocation.split(';').map(item => item.trim()): [],
      exclude_schoollocation: data.exclude_schoollocation && data.exclude_schoollocation.length ? data.exclude_schoollocation.split(';').map(item => item.trim()): [],
      
      needcuratedtalentpooltags: data.needcuratedtalentpooltags ? true : false

    }
  }

  private capitalizeFirstLetter(string) {
    if(string && string != null){
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return string;
  }
  
  private buildExcludedJobTitle(jobtitle : any){
    console.log(jobtitle, 'jobtitlejobtitle')
    jobtitle = jobtitle.split('; ')
    if(jobtitle && jobtitle.length){
      return jobtitle.map(item => {
        return {
          key: item,
          isExcluded: true
        };
      })
    }
  }

  private buildJobTitle(jobtitle : any){
    console.log(jobtitle, 'jobtitlejobtitlejobtitle')
     
    let jobtitleArray = jobtitle.split('; ')
    return jobtitleArray
    // console.log(jobtitle, 'jobtitlejobtitlejobtitle')
    // if(jobtitleArray && jobtitleArray.length){
    //   console.log(jobtitleArray, 'jobtitleArrayjobtitleArrayjobtitleArray')
    //   jobtitleArray = jobtitleArray.map(item => {
    //     return {
    //       key: item,
    //       isExcluded: false
    //     };
    //   })
    //   console.log(jobtitleArray, 'jobtitleArrayjobtitleArrayjobtitleArray')

    //   return jobtitleArray;
    // }else{
    //   return [];
    // }

  }

  getGenderResult(data: any){
    if(data && data != null){
      data = data.toString().toLowerCase();
      if(data == 'all'){
        return 'All'
      }else if(data == 'male'){
        return 'Male'
      }else if(data == 'female'){
        return 'Female'
      }else if(data == 'not known'){
        return 'Not Known'
      }
    }
    return data
  }

  showGender(data: any){
    if(data && data != null){
      data = data.toString().toLowerCase();
      if(data == 'all'){
        return 'All'
      }else if(data == 'male'){
        return 'Men'
      }else if(data == 'female'){
        return 'Women'
      }else if(data == 'not known'){
        return 'Not Known'
      }
    }
    return data
  }

  editSavedSearch(history) {
    const modalRef = this.modalService.open(SaveSearchModalComponent, { windowClass: "small-modal", centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.talentdiscoveryhistoryid = history?.talentdiscoveryhistoryid;
    modalRef.componentInstance.searchName = history?.talentdiscoveryname;
    modalRef.result
    .then((message: any) => {
      if(message && message === 'Saved successfully') {
        this.successMessage = 'Search updated successfully';
        this.starthistory = 0;
        setTimeout(() => this.successMessage = '', 5000);
      }
    })
    .catch((err: any) => {
      this.errorMessage = 'Something went wrong';
      setTimeout(() => this.errorMessage = '', 5000);
    })
    .finally(() =>{
      this.starthistory = 0;
      this.viewSavedHistoryUpdate.emit('REFRESH');
    } )
  }
  
  triggerDeleteSaveModal(history) {
    this.savedSearchToDelete = history;
    this.deleteModalRef = this.modalService.open(this.deleteSavedSearchModal, { size :'md' as 'lg', centered: true, keyboard: false, backdrop: 'static' });
    this.deleteModalRef.result.then(() => { this.deleteModalRef = null; this.savedSearchToDelete = null; });
  }

  deleteSavedSearch() {
    if(this.savedSearchToDelete) {
      const payload = {
        talentdiscoveryhistoryid: this.savedSearchToDelete.talentdiscoveryhistoryid,
        issaved: 0
      }
      this.personSearchService.saveSearch(payload, true).subscribe((res: any) => {
        if(res && res.status === 'success') {
          this.deleteModalRef.close();
          this.successMessage = 'Saved search deleted successfully';
          this.starthistory = 0;
          setTimeout(() => this.successMessage = '', 5000);
        } else {
          this.deleteModalRef.close();
          this.errorMessage = 'Something went wrong';
          setTimeout(() => this.errorMessage = '', 5000);
        }
      }, (err: any) => {
        this.deleteModalRef.close();
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      })
        .add(() => this.viewSavedHistoryUpdate.emit('REFRESH'));
    }
  }

  private getSafeKey(str: string): string {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
  }
}
